import { EmailTemplateListDto } from "@common/dto/email-template/list";
import { HttpSuccessDto } from "@common/dto/http";
import { clientTransformed } from "@common/utils/rest";

const URL_PREFIX = 'api/invites';

const getUrl = (path: string) => {
  return `${URL_PREFIX}/${path}`;
};

export const getEmailTemplates = () => {
  return clientTransformed({
    path: getUrl('loadEmailTemplates'),
    method: 'GET',
  }).then(
    (response: HttpSuccessDto<Array<EmailTemplateListDto>>) => {
      return response.entity;
    },
  );
};